<template>
  <div>
    <div class="main-title">优惠历史记录</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索单据编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.discount_oper_id"
              placeholder="优惠操作员"
              clearable
              @change="search(searchParams)">
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="120">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收金额"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="优惠"
          width="70">
        </el-table-column>
        <el-table-column
          prop="discount_time"
          label="优惠时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="discount_oper_name"
          label="优惠操作员"
          width="100">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="160">
        </el-table-column>
        <el-table-column
          prop="student_count"
          label="学员人数"
          width="80">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="140">
        </el-table-column>
        <el-table-column
          prop="pay_cash"
          label="现金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_alipay"
          label="支付宝"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_wechat"
          label="微信支付"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_pos"
          label="银行卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_balance"
          label="充值卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_coupon"
          label="代金券"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'">
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="150">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      billList: [],
      sqlcode: 'discount_history',
      searchForm: {
        query: '',
        daterange: [
          this.user.buttons.indexOf(1020) < 0 ? new Date() : new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
          new Date()
        ],
        discount_oper_id: null
      },
      userList: [],
      sumProps: [
        'fee',
        'fee_discount',
        'pay_total'
      ]
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          discount_oper_id: this.searchForm.discount_oper_id,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchUserList()
  },
  methods: {
    fetchUserList () {
      this.$http.get('/dbapi/user_combo').then(response => {
        if (response.data.success) {
          this.userList = response.data.list
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'bill_no') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/return/DiscountHistory.vue